var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512.093 512.093",
    height: 512,
    viewBox: "0 0 512.093 512.093",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m365.992 432.048h-154.99c-66.168 0-120-53.832-120-120v-123c0-61.51-30.658-118.445-82.009-152.303-9.222-6.08-11.768-18.484-5.688-27.706 6.08-9.223 18.483-11.77 27.707-5.688 29.314 19.328 53.096 44.82 70.102 74.17 3.675 4.117 33.309 35.527 81.889 35.527h230.307c62.834-1.175 112.015 61.882 95.587 122.532l-26.512 105.67c-13.413 53.46-61.275 90.798-116.393 90.798zm-240.036-290.299c3.325 15.361 5.046 31.2 5.046 47.299v123c0 44.112 35.888 80 80 80h154.99c36.745 0 68.653-24.892 77.595-60.532l26.512-105.67c9.762-36.038-19.465-73.495-56.789-72.798h-230.308c-21.971 0-41.095-4.737-57.046-11.299zm75.046 345.299c0-13.807-11.193-25-25-25-33.172 1.321-33.143 48.692 0 50 13.807 0 25-11.193 25-25zm199 0c0-13.807-11.193-25-25-25-33.172 1.321-33.143 48.692 0 50 13.807 0 25-11.193 25-25zm33.308-274c0-11.046-8.954-20-20-20h-222.308c-26.536 1.056-26.516 38.953 0 40h222.308c11.046 0 20-8.954 20-20z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.98ab5e74.svg";
export { ForwardRef as ReactComponent };